export default __webpack_public_path__ + "static/media/sponsor-medina-firula.e868ec0a.png";